import { bulkResizeSlice } from "./slice";

export const {
    // resize
    setColor,
    setDPI,
    setDimensionType,
    setHeight,
    setIsLocked,
    setPercentage,
    setSocialMediaPlatform,
    setSocialMediaPlatformPreset,
    setShouldFillColor,
    setUnit,
    setWidth,
    setFillColorType,
    // filter
    setSort,
    // images
    addImage,
    deleteImage,
    deleteAllImages,
    setImages,
    setDimension,
    setImageState,
    setImporting,
    setIsCorrupted,
    // export settings
    setFileUnit,
    setMaxFileSize,
    setOptimizationLevel,
    setSaveAs,
    reset,
    // crop
    cropSetHeight,
    cropSetWidth,
    cropSetRatio,
    cropToggleCropOrientation,
    cropSetLeft,
    cropSetTop,
    cropSetCropBox,
    cropReset,
    cropHandleCropBoxChange,
    cropSetCustomRatioX,
    cropSetCustomRatioY,
    cropSetPreview,
    // flip
    flipToggleHorizontal,
    flipToggleVertical,
    flipReset,
    // rotate
    rotateSetStraighten,
    rotateSetRotation,
    rotateReset,
    rotateSetInitialData,
    // operaions
    addOperation,
    deleteAllOperations,
    setOriginal,
    setPreview,
    setEditImageModal,
} = bulkResizeSlice.actions;
